import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { composeWithDevTools } from "redux-devtools-extension";
import reduxThunk from "redux-thunk";
import rootReducer from "./reducer/index";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["Auth"], 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewares = [reduxThunk];

const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middlewares))
);

export const persistor = persistStore(store);
export default store;
